import sample from 'lodash-es/sample';

export const stockTemplateImageUrls = [
  'https://storage.googleapis.com/ttc-static-images/programs/blue-70s-vibes.AB2C130.png',
  'https://storage.googleapis.com/ttc-static-images/programs/night-70s-vibes.8CF0BBC.png',
  'https://storage.googleapis.com/ttc-static-images/programs/red-70s-vibes.0E5B070.png',
  'https://storage.googleapis.com/ttc-static-images/programs/teal-70s-vibes.9F72163.png',
];

export function getRandomProgramTemplatePhotoUrl() {
  return sample(stockTemplateImageUrls);
}
